module.exports = __webpack_public_path__ + "static/media/pic4.8cef452f.jpg";